export const iconFontAwesomeFilesFileWord = (
	<i className="fa-solid fa-file-word"></i>
);
